<template>
    <div class="header">
      <div class="top">
        <div class="title">
          象棋等级考试指定网站
          <!-- <img src="../assets/imgs/grad_titles.png"> -->
        </div>
        <!-- <div class="login">
          <img src="../assets/imgs/logo.png">
        </div> -->
      </div>
    </div>
</template>

<script>
export default {
  name: 'gradingHeader'
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .header{
    width:100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    height: 140px;
    background-color: #008EE9;
    .top{
      width: 100%;
      @media only screen and (min-width: 540px) and (max-width: 1180px){
        width: 1180px;
      }
      height: 140px;
      @include flex();
      padding: 0 95px;
      margin: 0 auto;
      box-sizing: border-box;
      .title{
        background-color: #008de9;
        color: #fff;
        font-size: 50px;
        font-family: 'SimSun';
        font-weight: bold;
      }
      .login{
        width: 185px;
        height: 75px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/gradingHeader.vue